// @material-ui/core
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography
} from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { Add as AddIcon, Remove as RemoveIcon } from "@material-ui/icons/Add";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withRouter } from "react-router";
import { compose } from "redux";
import MainButton from "../../library/button/MainButton";
import Caba from "../../services/Caba";

const styles = theme => ({
  button: {
    marginTop: theme.spacing.unit * 2
  }
});

class CustomerEdit extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      customer: {
        id: "",
        customerId: "",
        numberOfUsers: 0,
        name: "",
        primaryDomain: "",
        domainList: [],
        superAdmin: ""
      }
    };

    props.toggleLoading(true);
    // make a call
    Caba.get("/api/v1/customers/" + props.match.params.id).then(response => {
      console.log(response.data);
      this.props.toggleLoading(false);
      this.setState({
        customer: response.data
      });
    });
  }

  handleChangeCustomer = name => event => {
    // const customer = this.state.customer
    // customer[name] = event.target.value
    // this.setState({customer});

    this.setState({
      customer: { ...this.state.customer, [name]: event.target.value }
    });
  };

  handleChangeDomain = index => event => {
    console.log("before", this.state.customer.domainList);
    const domains = this.state.customer.domainList.map(
      (domain, currentIndex) => {
        if (index !== currentIndex) {
          return domain;
        }
        return event.target.value;
      }
    );
    console.log("after", domains);
    this.setState(prevState => ({
      customer: {
        ...prevState.customer,
        domainList: domains
      }
    }));
  };

  handleClick = event => {
    console.log("should save it now");

    Caba.put(
      "/api/v1/customers/" + this.props.match.params.id,
      this.state.customer
    )
      .then(response => {
        console.log(response.data);
        this.props.notify("success", "Customer saved.");
      })
      .catch(err => {
        console.log(err);
        this.props.notify(
          "failure",
          "Something went wrong while tryin to save customer."
        );
      });
  };

  handleAddDomain = () => {
    this.setState(prevState => ({
      customer: {
        ...prevState.customer,
        domainList: [...prevState.customer.domainList, ""]
      }
    }));
  };

  handleRemoveDomain = () => {
    if (this.state.customer.domainList.length > 0) {
      this.setState(prevState => ({
        customer: {
          ...prevState.customer,
          domainList: prevState.customer.domainList.slice(
            0,
            prevState.customer.domainList.length - 1
          )
        }
      }));
    }
  };

  render() {
    // const {location, match} = this.props
    const { customer } = this.state;
    const { classes } = this.props;

    return (
      <Card>
        <CardHeader title={this.state.customer.name} />
        <CardContent>
          <Grid container>
            <Grid item xs={12}>
              <Typography type="subheading">
                <small>Customer</small>
              </Typography>

              {/* <Typography type="title">
            {customer.name}
          </Typography> */}
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Typography type="subheading">
                    <small>Name</small>
                  </Typography>
                  <TextField
                    id="name"
                    value={customer.name}
                    onChange={this.handleChangeCustomer("name")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography type="subheading">
                    <small>ID</small>
                  </Typography>
                  <TextField
                    id="id"
                    value={customer.id}
                    onChange={this.handleChangeCustomer("id")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography type="subheading">
                    <small>Primary Domain</small>
                  </Typography>
                  <TextField
                    id="primaryDomain"
                    value={customer.primaryDomain}
                    onChange={this.handleChangeCustomer("primaryDomain")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography type="subheading">
                    <small>Number of users</small>
                  </Typography>

                  <TextField
                    id="numberOfUsers"
                    value={customer.numberOfUsers}
                    onChange={this.handleChangeCustomer("numberOfUsers")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography type="subheading">
                    <small>Super Admin</small>
                  </Typography>
                  <TextField
                    id="superAdmin"
                    value={customer.superAdmin}
                    onChange={this.handleChangeCustomer("superAdmin")}
                    margin="dense"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Typography type="subheading">
                    <small>
                      Domains{" "}
                      <Button onClick={this.handleAddDomain} fab mini>
                        <AddIcon />
                      </Button>
                      <Button onClick={this.handleRemoveDomain} fab mini>
                        <RemoveIcon />
                      </Button>
                    </small>
                  </Typography>
                </Grid>
                {this.state.customer.domainList.map((domain, index) => (
                  <Grid item xs={12} md={6} key={domain + index}>
                    <TextField
                      value={domain}
                      onChange={this.handleChangeDomain(index)}
                      margin="dense"
                      id={domain + index}
                      fullWidth
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <MainButton
                onClick={event => this.handleClick(event)}
                className={classes.button}
                raised
                fullWidth
                colored="blue">
                Save
              </MainButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default compose(withRouter, withStyles(styles))(CustomerEdit);



// WEBPACK FOOTER //
// ./src/pages/customers/CustomerEdit.js